import { useMutation } from '@hooks/reactQuery';

import { getMoTreePaths } from '@api/configurationComparison';

import { setCheckboxListForPaths } from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/utils';

import { IBranchSelectedPaths } from '@interfaces/cmModule/cmModule';
import { IBranchPaths } from '@interfaces/cmModule/configurationComparison';
import {
	IMavenirSelectChangeCallback,
} from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/FlatTreeMavenir/interfaces';

import { MO_BRANCHES_GET_PATHS } from '@constants/queryKeys';

const tailSlashRgx = /\/$/;

interface IUseMutateSelectedPathsReturnType {
	getNodePaths: (data: IMavenirSelectChangeCallback) => void;
	nodePaths?: IBranchSelectedPaths[];
	isLoadingGetNodePaths: boolean;
}

export const useMutateSelectedPaths = (): IUseMutateSelectedPathsReturnType => {
	const {
		data: nodePaths,
		mutateAsync: getNodePaths,
		isLoading,
	} = useMutation<IBranchPaths, IBranchSelectedPaths[]>({
		mutationKey: [MO_BRANCHES_GET_PATHS],
		mutationFn: async ({ dumpId, path, node, setData }: IMavenirSelectChangeCallback) => {
			if (!path && !node) {
				return;
			}

			const data = await getMoTreePaths({ path, dumpId });

			if (!data?.length) {
				return;
			}

			const clearedPathData = data.map((item) => {
				return {
					...item,
					path: item.path.replace(tailSlashRgx, ''),
				};
			}).reduce((acc, item) => {
				return { ...acc, [item.path]: item.moIds };
			}, {});

			setCheckboxListForPaths({
				node,
				data: clearedPathData,
				setData,
			});
		},
	});

	return {
		getNodePaths,
		nodePaths,
		isLoadingGetNodePaths: isLoading,
	};
};
